// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1f-0";
export var spinnerContainer = "_1f-1";